"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("./Input"));

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _MultiInputModule = _interopRequireDefault(require("./MultiInput.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VALUE_ADD_KEYS = ['Tab', 'Enter'];
var VALUE_REMOVE_KEYS = ['Delete', 'Backspace'];

var MultiInput = function MultiInput(_ref) {
  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      children = _ref.children,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      wrapperRef = _ref.wrapperRef,
      onInputChange = _ref.onInputChange,
      onValueAdd = _ref.onValueAdd,
      onValueRemove = _ref.onValueRemove,
      forwardedRef = _ref.forwardedRef,
      maxValues = _ref.maxValues,
      valueContent = _ref.valueContent,
      defaultValues = _ref.defaultValues,
      valuesFromProps = _ref.values,
      props = _objectWithoutProperties(_ref, ["className", "inputClassName", "children", "defaultValue", "placeholder", "wrapperRef", "onInputChange", "onValueAdd", "onValueRemove", "forwardedRef", "maxValues", "valueContent", "defaultValues", "values"]);

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultValues),
      _useState4 = _slicedToArray(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!valuesFromProps) return;

    if (valuesFromProps !== values) {
      setValues(valuesFromProps);
    }
  }, [valuesFromProps]);
  var inputRef = forwardedRef !== undefined ? forwardedRef : (0, _react.useRef)(null);

  function setFocus() {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  function onChange(evt) {
    var value = evt.currentTarget.value;
    setInput(value);
    onInputChange(value, evt);
  }

  function addValue(value) {
    if (!value) {
      return;
    }

    setInput('');
    onInputChange('');
    var valuesSet = new Set(values);

    if (!values.includes(value)) {
      var newValues = _toConsumableArray(values).concat([value]);

      onValueAdd(value, newValues);
      setValues(newValues);
    }
  }

  function removeValue(value) {
    var newValues = values.filter(function (item) {
      return item !== value;
    });
    setValues(newValues);
    onValueRemove(value, newValues);
  }

  function onKeyDown(evt) {
    if (VALUE_ADD_KEYS.includes(evt.key)) {
      evt.preventDefault();
      addValue(evt.currentTarget.value);
    }

    if (VALUE_REMOVE_KEYS.includes(evt.key) && !input) {
      evt.preventDefault();
      removeValue(values[values.length - 1]);
    }
  }

  var shouldShowInput = maxValues ? values.length < maxValues : true;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(className, _MultiInputModule.default.wrapper),
    ref: wrapperRef,
    onClick: setFocus
  }, _react.default.createElement("div", {
    className: _MultiInputModule.default.values
  }, values.map(function (item, idx) {
    return _react.default.createElement(_Button.default, {
      border: true,
      className: _MultiInputModule.default.value,
      key: idx,
      onClick: function onClick(evt) {
        evt.stopPropagation();
      }
    }, valueContent ? valueContent(item) : item, _react.default.createElement(_Icon.default, {
      type: "close-small",
      className: _MultiInputModule.default.delete,
      onClick: function onClick() {
        return removeValue(item);
      }
    }));
  }), shouldShowInput && _react.default.createElement(_Input.default, _extends({
    size: values.length === 0 ? placeholder.length : input.length + 1,
    placeholder: values.length > 0 ? '' : placeholder,
    className: (0, _classnames.default)(inputClassName, _MultiInputModule.default.input),
    onChange: onChange,
    onKeyDown: onKeyDown,
    value: input,
    forwardedRef: inputRef
  }, props))), children);
};

process.env.NODE_ENV !== "production" ? MultiInput.propTypes = {
  className: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  valueContent: _propTypes.default.func,
  onInputChange: _propTypes.default.func,
  onValueAdd: _propTypes.default.func,
  onValueRemove: _propTypes.default.func,
  maxValues: _propTypes.default.number
} : void 0;
MultiInput.defaultProps = {
  className: '',
  onInputChange: function onInputChange() {},
  onValueAdd: function onValueAdd() {},
  onValueRemove: function onValueRemove() {},
  defaultValues: []
};
var _default = MultiInput;
exports.default = _default;